import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CalendarTodaySharp } from '@material-ui/icons';
import Board from 'react-trello';
import MyCard from './card'
import MyLaneHeader from './header'
import moment from 'moment';
import './styles.css'

const components = {
    Card: MyCard,
    LaneHeader: MyLaneHeader,
  };

const styles = theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(24),
        margin: '0 24px',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    panel: {
        marginTop: theme.spacing.unit * 2,
    },
    base: {
        padding: '8px',
        borderRadius: '50%',
        marginRight: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    green: {
        backgroundColor: '#239D05',
        },
    yellow: {
        backgroundColor: '#F0F418',
    },
    red: {
        backgroundColor: '#B00A0A',
    },
    gray: {
      backgroundColor: '#8A8A8A',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

});

const makeCols = (data, tipo, fecha, turno) => {
  const cols = {
    lanes: [
      {
        id: 'lane1',
        title: 'CONFIRMADOS',
        cards: []
      },
      {
        id: 'lane2',
        title: 'PREPARADOS',
        cards: []
      },
      {
        id: 'lane3',
        title: 'ENTREGADOS',
        cards: []
      },
    ]
  }

  data.pedidos.forEach(pedido => {
    const card = {
        metadata : {
          ...pedido,
          tipo,
          horaInicio: data.horaInicio,
          horaFin: data.horaFin,
          fecha,
          turno,
        }
    }
    cols.lanes[pedido.descripcion === 'Confirmado' ? 0 : pedido.descripcion === 'Preparado' ? 1 : 2].cards.push(card)
  })
  return cols;
}
// 3 confirmados - 2 preparados - 0 entregados
  const calculatePedidosState = (pedidos) => {
    let message = ''
    let confirmados = 0
    let preparados = 0
    let entregados = 0
    if(pedidos.length === 0) {
        message = '0 confirmados - 0 preparados - 0 entregados'
    }
    pedidos.forEach(pedido => {
        if(pedido.descripcion === 'Confirmado') {
            confirmados++
        } else if(pedido.descripcion === 'Preparado') {
            preparados++
        } else if(pedido.descripcion === 'Entregado') {
            entregados++
        }
    })
    message = `${confirmados} confirmados - ${preparados} preparados - ${entregados} entregados`
    return message
  }

  const calculateCalendarColor = (data, classes, fecha) => {
    const { pedidos, horaInicio } = data;
    if(pedidos.length === 0) {
        return classes.gray
    }
    for(var pedido of pedidos) {
      if(pedido.descripcion === 'Confirmado' && moment(moment().format('YYYY-MM-DD')).isAfter(moment(fecha))) {
        return classes.red
      }

      if(pedido.descripcion === 'Confirmado' && moment().isAfter(moment(`${fecha} ${horaInicio}`))) {
        return classes.red
      }

      if(pedido.descripcion === 'Confirmado' && moment().isSameOrBefore(moment(`${fecha} ${horaInicio}`))) {
        return classes.yellow
      }

      if(pedido.descripcion === 'Confirmado' && moment(moment().format('YYYY-MM-DD')).isSameOrBefore(moment(fecha))) {
        return classes.yellow
      }
    }
    return classes.green
  }

const Turno = ({ classes, handleChange, expanded, data, value, tipo, fecha }) => {
    const turnoStyle = calculateCalendarColor(data, classes, fecha)
    return (
        <ExpansionPanel className={classes.panel} expanded={expanded === value} onChange={handleChange(value)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <div className={classes.content}>
                    <div className={[classes.base, turnoStyle].join(' ')}>
                        <CalendarTodaySharp />
                    </div>
                    <Typography className={classes.heading}>{data.turnoNombre}</Typography>
                    <Typography className={classes.secondaryHeading}>{calculatePedidosState(data.pedidos)}</Typography>
                </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <div style={{display:'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                    <Board 
                        cardDraggable={false}
                        components={components}
                        data={makeCols(data, tipo, fecha, data.turnoNombre)} 
                        style={{backgroundColor: 'transparent', height: 'auto', width: '100%'}} 
                        laneStyle={{backgroundColor: '#EFF0F8', minWidth: '330px', marginLeft: '20px', width: 'auto'}}
                        tagStyle={{backgroundColor: 'transparent'}}
                        cardStyle={{backgroundColor: 'transparent'}}
                        />
                </div>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );

}

Turno.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Turno);